<template lang="html">
  <span class="">
    <span v-if="loading" class="loading text-center"><i class="far fa-pulse fa-spinner"></i></span>
    <span v-if="member">{{ member.name_first }} {{ member.name_last }}</span>
  </span>
</template>

<script>
import Vue from 'vue'

export default {
  props: ['memberId', 'guarantorAccountId'],
  data () {
    return {
      loading: true,
      member: null,
    }
  },
  computed: {

  },
  mounted() {
    if(this.memberId) {
        Vue.db.ref(`/members/${this.memberId}`)
          .once('value')
          .then(snapshot => {
            if(snapshot.val()) {
              this.member = snapshot.val();
              this.loading = false;
            } else {
              // console.log("error loading member's status");
            }
          })
          .catch(err => console.log(err));
    } else {
      console.error("no data to load")
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";
</style>
